module.exports = __webpack_public_path__ + "static/media/popupTri2.0934851c.png";